<ng-container *ngIf="isOffcanvas">
  <div appDragClose [dragThreshold]="100" (dragClose)="closeOffcanvas()">
    <div class="drag-handle">
      <div class="drag-indicator"></div>
    </div>
    <div class="offcanvas-header">
      <h5 id="offcanvasLabel" class="mb-0">{{ getModalTitle() }}</h5>
      <button type="button" class="btn-close no-drag" (click)="closeOffcanvas()"></button>
    </div>
  </div>
  <div ngbAutoFocus class="offcanvas-content">
    <ng-template [ngTemplateOutlet]="bodyContentTemplate"></ng-template>
  </div>
  <div class="offcanvas-actions d-flex align-items-center w-100">
    <ng-template [ngTemplateOutlet]="actionsContentTemplate"></ng-template>
  </div>
</ng-container>

<ng-container *ngIf="!isOffcanvas">
  <app-modal [title]="getModalTitle()" class="app-modal">
    <div class="modal-content pt-0" style="overflow: visible">
      <div class="d-none" ngbAutoFocus></div>
      <ng-template [ngTemplateOutlet]="bodyContentTemplate"></ng-template>
    </div>
    <div class="modal-actions d-flex align-items-center w-100">
      <ng-template [ngTemplateOutlet]="actionsContentTemplate"></ng-template>
    </div>
  </app-modal>
</ng-container>

<ng-template #bodyContentTemplate>
  <div class="modal-info-message">
    <i class="bi bi-info-circle-fill"></i>
    <span>{{ 'Thank you for using our portal! Help us to improve the service by sharing your feedback.' | translate}}</span>
  </div>
  <formly-form [fields]="reviewFields" [model]="formModel" [form]="reviewForm"></formly-form>
</ng-template>

<ng-template #actionsContentTemplate>
  <div class="d-flex ms-auto">
    <app-button label="{{ 'Submit Review' | translate }}" [isDisabled]="!canSubmit()"
      (onClick)="onSubmit()"></app-button>
  </div>
</ng-template>